import { Link } from "react-router-dom";

// Logo ScreenView : blanc sur fond transparent ; variant="color" (bleu ciel / bleu nuit) pour les fonds clairs.
export const LogoMark = ({ className = "h-9 w-9", variant = "white" }) => (
  <img src={variant === "color" ? "/logo.png?v=f5" : "/logo-white.png?v=f5"} alt="" aria-hidden="true" className={`${className} object-contain`} data-testid="logo-mark" draggable={false} />
);

export const Logo = () => (
  <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
    <LogoMark />
    <span className="font-extrabold tracking-tight text-lg">ScreenView</span>
  </Link>
);

const IMG = "https://images.pexels.com/photos/37605911/pexels-photo-37605911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const AuthShell = ({ kicker, title, children }) => (
  <div className="min-h-screen grid lg:grid-cols-[1fr_1fr] bg-[#090D16]">
    <div className="flex flex-col justify-center px-8 sm:px-16 py-12 grid-bg">
      <div className="fade-up w-full max-w-sm">
        <div className="mb-12"><Logo /></div>
        <p className="font-mono text-xs tracking-widest text-sky-400 mb-3">{kicker}</p>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-8">{title}</h1>
        {children}
      </div>
    </div>
    <div className="hidden lg:block relative">
      <img src={IMG} alt="Salle serveurs" className="absolute inset-0 h-full w-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#090D16] to-transparent" />
    </div>
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{label}</span>
    <div className="mt-1.5">{children}</div>
  </label>
);
